export default "__VITE_ASSET__CzErDBzY__"